/**
 * Советы о связи кассы AQSI — один словарь на код причины (RP-UI-LINK). Служба отдаёт причину кодом (`reasonCode`) и фактом словами
 * (`reason`, показывается дословно); что делать человеку, знает только этот словарь — копий совета нет ни на сервере, ни в экранах.
 */

/** Ключ действия «Актуализировать состояние кассы» в мини-окне точки «Связь»: исполняет экран РМК. */
export const REGISTER_REFRESH_ACTION = 'aqsi.register.refresh'

export const REGISTER_REFRESH_LABEL = 'Актуализировать состояние кассы'

/** Ключ действия «Обновить» у кабинета, пока работы за кассой нет («Начало работы»): перечитать кассы и смены. */
export const CABINET_RELOAD_ACTION = 'aqsi.cabinet.reload'

/** Причины связи кассы и кабинета: коды службы (`AqsiLinkReasonCodes`) и свои — для уровня кабинета. */
export type AqsiLinkAdviceKey =
  | 'no-answer'
  | 'not-probed'
  | 'stale'
  | 'unconfirmed'
  | 'refused'
  | 'cabinet-unavailable'
  | 'busy'
  | 'cabinet-error'
  | 'cabinet-read-failed'

export const AQSI_LINK_ADVICE: Readonly<Record<AqsiLinkAdviceKey, string>> = {
  'no-answer': `Включите кассу, проверьте заряд и Wi-Fi или SIM, затем нажмите «${REGISTER_REFRESH_LABEL}».`,
  'not-probed': `Касса ещё не проверялась. Чтобы узнать, отвечает ли она, нажмите «${REGISTER_REFRESH_LABEL}».`,
  stale: `Последняя проверка кассы давно. Чтобы проверить сейчас, нажмите «${REGISTER_REFRESH_LABEL}».`,
  unconfirmed: 'Кабинет AQSI принял проверку, но не назвал итог. Обычно касса при этом работает; если команда не пройдёт, проверьте кассу ещё раз.',
  refused:
    'Кабинет AQSI отказал в проверке. Проверьте ключ кабинета и магазин в настройках подключения; если не помогает — передайте текст администратору.',
  'cabinet-unavailable': 'Не отвечает кабинет AQSI — о самой кассе это ничего не говорит. Подождите и проверьте снова.',
  busy: 'Проверку сейчас отправить нельзя. Дождитесь окончания работы на кассе и проверьте снова.',
  'cabinet-error': `Продавать нельзя, пока кабинет AQSI не ответит. Подождите и нажмите «${REGISTER_REFRESH_LABEL}».`,
  'cabinet-read-failed':
    'Список касс не показан: прошлый не показываем, чтобы не начать работу по устаревшим данным. Подождите и нажмите «Обновить».',
}
